import { c as _c } from "react/compiler-runtime";
import cn from "classnames";
import { Icons } from "./ChecklistIcons";
interface ChecklistItemProps {
  item: {
    title: string;
    info: string;
  };
  isChecked: boolean;
  onToggle: () => void;
}
export const ChecklistItem = t0 => {
  const $ = _c(31);
  const {
    item,
    isChecked,
    onToggle
  } = t0;
  const t1 = !isChecked;
  let t2;
  if ($[0] !== isChecked || $[1] !== t1) {
    t2 = cn("checklist-item-box flex items-center gap-2 p-2 md:p-3 rounded-xl cursor-pointer transition-all duration-200 border", {
      "bg-slate-100 dark:bg-slate-900 border-slate-200 dark:border-slate-800 text-slate-400 dark:text-slate-500": isChecked,
      "bg-white dark:bg-slate-850 border-slate-200 dark:border-slate-750 hover:border-brand-500 dark:hover:border-brand-500 text-slate-900 dark:text-slate-100 shadow-sm": t1
    });
    $[0] = isChecked;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !isChecked;
  let t4;
  if ($[3] !== isChecked || $[4] !== t3) {
    t4 = cn("w-4 h-4 md:w-5 md:h-5 rounded flex items-center justify-center border-2 transition-colors shrink-0", {
      "bg-brand-500 border-brand-500": isChecked,
      "border-slate-300 dark:border-slate-600": t3
    });
    $[3] = isChecked;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isChecked) {
    t5 = isChecked && <Icons.Check className="w-3 h-3 text-white" />;
    $[6] = isChecked;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== isChecked) {
    t7 = cn("text-xs md:text-sm leading-tight", {
      "line-through opacity-50": isChecked
    });
    $[11] = isChecked;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== item.title || $[14] !== t7) {
    t8 = <span className={t7}>{item.title}</span>;
    $[13] = item.title;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== item.info) {
    t9 = item.info && <div className="group relative no-print" onClick={_temp}><Icons.Info className="w-4 h-4 text-slate-400 hover:text-brand-500 transition-colors" /><div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-48 p-2 bg-slate-800 text-white text-[10px] rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">{item.info}<div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-slate-800" /></div></div>;
    $[16] = item.info;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div className="flex items-center gap-1">{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== item.info) {
    t11 = item.info && <span className="text-[10px] text-slate-500 mt-1 print-only">{item.info}</span>;
    $[21] = item.info;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <div className="flex flex-col">{t10}{t11}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== onToggle || $[27] !== t12 || $[28] !== t2 || $[29] !== t6) {
    t13 = <div onClick={onToggle} className={t2}>{t6}{t12}</div>;
    $[26] = onToggle;
    $[27] = t12;
    $[28] = t2;
    $[29] = t6;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
};
function _temp(e) {
  return e.stopPropagation();
}